<template>
  <v-layout column class="_login-section">
    <v-flex class="_signup-layout--benefits-section app-bg-sand">
      <v-container>
        <v-layout column justify-center text-xs-center>
          <v-flex tag="h1" class="_signup-layout--header">Register now</v-flex>
        </v-layout>
      </v-container>

      <!-- BACKGROUND ELEMENTS -->
      <v-flex v-if="$vuetify.breakpoint.mdAndUp" class="_signup-layout--bg-elements">
        <div v-parallax="$helpers.getSpeedAnimationDown()" class="smooth-parallax">
          <app-svg-icon name="brand/NG_AGES_5+" color="var(--yellow)" class="svg-icon--ages"></app-svg-icon>
        </div>
        <div v-parallax="$helpers.getSpeedAnimationDown()" class="smooth-parallax">
          <app-svg-icon name="patterns/NG_Pattern-16" color="none var(--orange)"
            class="svg-icon--pattern-16"></app-svg-icon>
        </div>
        <div v-parallax="$helpers.getSpeedAnimationUp()" class="smooth-parallax">
          <app-svg-icon name="patterns/NG_Pattern-03" color="none var(--green)"
            class="svg-icon--pattern-03"></app-svg-icon>
        </div>
        <div v-parallax="$helpers.getSpeedAnimationDown()" class="smooth-parallax">
          <app-svg-icon name="brand/NG_HAS_CAR" color="var(--blue)" class="svg-icon--car"></app-svg-icon>
        </div>
      </v-flex>
    </v-flex>

    <v-flex class="_login-section--benefits">
      <v-container fill-height grid-list-xl>
        <app-auth-benefits></app-auth-benefits>
      </v-container>
    </v-flex>

    <!-- ✅ Already a member section -->
    <v-flex text-xs-center>
      <p class="font-weight-bold mt-4">
        Already a member?
        <router-link to="/login" class="font-weight-bold">
          Login
        </router-link>
      </p>
    </v-flex>

  </v-layout>
</template>


<script>
import AppScrollPatterns from '../../../../components/app-scroll-patterns'
import AuthSocial from '../components/auth-social'
import AuthLoginEmail from '../components/auth-login-email'
import AppAuthBenefits from '../components/app-auth-benefits copy'

export default {
  components: { AppScrollPatterns, AppAuthBenefits, AuthLoginEmail, AuthSocial },
  props: {
    inputRole: {
      type: String,
      default: 'parent'
    },
    viewLogin: Boolean,
    register: Boolean
  },
  data() {
    return {
      loading: {
        facebook: false,
        google: false
      },
      code: this.$route.query.code,
      type: this.$route.params.type // <- provider
    }
  },
  methods: {
    social(type) {
      this.loading[type] = true
      this.$auth.oauth2({
        provider: type || this.type,
        params: {
          redirect_uri: this.redirectURI(type),
          // Specifies value that the application uses to maintain state
          // between your authorization request and the authorization server's response
          state: (this.register ? 'register' : 'login')
        }
      })
    },
    redirectURI(type) {
      return `${this.$auth.options.getUrl()}/oauth2/${type || this.type}/${this.role}`
    }
  }
}
</script>

<style lang="stylus" scoped>
    ._login-section
        position relative
        &--sub-title
            margin-top 0px
            @media (min-width 600px)
                margin-top 0px
                margin-bottom 0px
            &.sub-title_second
                margin-top 0
                @media (min-width 600px)
                    margin-bottom 62px
        &--divider
            @media (min-width 600px)
                margin-top 0px
                margin-bottom 0px
            .svg-icon
                width 100px
                height 50px
                color var(--yellow)
                @media (min-width 600px)
                    width 139px
        &--benefits
            padding 0px
        &--bg-elements
            .svg-icon
                position absolute
                width 122px
                height 122px
                &--creative
                    color var(--yellow)
                    right 90px
                    bottom 350px
                &--pattern
                    left 40px
                    top 180px            
</style>
<style lang="stylus" scoped>
    ._signup-layout
        &--header
            margin 12px 0
        &--bg-elements
            .smooth-parallax
                top -43px
            .svg-icon
                position absolute
                &--ages
                    width 116px
                    height 116px
                    top -70px
                    left 16%
                    transform rotate(10deg)
                &--pattern-16
                    width 116px
                    height 116px
                    top -80px
                    right 11%
                &--pattern-03
                    width 116px
                    height 116px
                    top 70px
                    left -60px
                    transform rotate(75deg)
                &--car
                    width 116px
                    height 116px
                    top 180px
                    right 5%
                    transform rotate(23deg)
</style>


// WEBPACK FOOTER //
// src/views/app/auth/register/index.vue